import { oddsApiService } from '@nf/odds/services';
import { useObservableState } from '@nf/utils-common/hooks';
import { uiService } from '@/services/ui.service';
import { RefreshButton } from '@/components/core/refresh-button';
import { useEffect, useState } from 'react';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

interface MarketRefreshProps {
	isFromLive?: boolean;
}

export const MarketRefresh = ({ isFromLive }: MarketRefreshProps) => {
	const view = useAppearanceStore(state => state.view);
	const isFetching = useObservableState(uiService.marketPageRefreshIcon$, false);
	const [isLoading, setIsLoading] = useState(false);

	const refreshMarket = () => {
		setKafka();
		setIsLoading(true);
		uiService.spinMarketRefreshIcon(true);
		oddsApiService.sportOddsApi.refetchSport();
	};

	const setKafka = () => {
		if (view !== ViewEnum.galaxy) return;

		const kafkaData = {
			note: KafkaNote.GalaxyV2,
			type: 3,
			action: isFromLive ? 9 : 10
		}
		setKafkaNormal(kafkaData);
	}

	useEffect(() => {
		if (!isFetching) {
			setTimeout(() => {
				setIsLoading(false);
			}, 1000);
		}
	}, [isFetching]);

	return (
		<RefreshButton
			spinStarted={isLoading}
			onRefresh={refreshMarket}
		/>
	);
};